// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5507 ? "react-syntax-highlighter/refractor-import" : chunkId) + "." + {"5507":"23a0055b380bb60c","7441":"4f3bb6c4976a513a"}[chunkId] + ".js";
};